import { render } from "./CustomerSegmentCreate.vue?vue&type=template&id=50ae8c0e"
import script from "./CustomerSegmentCreate.vue?vue&type=script&lang=js"
export * from "./CustomerSegmentCreate.vue?vue&type=script&lang=js"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__